<template>
  <div
    class="paywall-container"
  >
    <img
      class="absolute left-0 top-0 w-full h-full object-cover blurry-background"
      src="../../assets/images/lens-paywall-background.jpg"
    >
    <!--  -->
    <PaywallCard
      class="upgrade-modal"
      :header="upgradeHeader"
      :subscription-type="subscriptionType"
      :upgrade-benefits="upgradeBenefits"
      :learn-more="'Learn more about Lens creative analytics'"
      :product-image="require('../../assets/images/lens-product-orb.png')"
      :demo-video="'https://www.youtube.com/watch?v=93_VRP1c_a4&ab_channel=foreplay'"
    />
  </div>
</template>

<script>
import PaywallCard from '../account/PaywallCard.vue'

export default {
  name: 'LensPaywallState',
  components: {
    PaywallCard
  },
  props: {
    subscriptionType: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const upgradeBenefits = [
      'Full access to Lens creative analytics.',
      'More free users included on your team.',
      'More Spyder brands to track.',
      'API & Agent Integrations.'
    ]
    return {
      upgradeBenefits
    }
  },
  computed: {
    upgradeHeader () {
      return this.subscriptionType.isBasic ? 'Upgrade your account to unlock Lens & Spyder.' : 'Get more for less by upgrading your legacy plan.'
    }
  },
  methods: {
    openDemoBook () {
      window.open('https://www.foreplay.co/book-demo', '_blank')
    }
  }
}
</script>

<style scoped>
.paywall-container{
  position: relative;
  width: 100%;
  height: calc(100vh - 86px);

  display: flex;
  justify-content: center;
  align-items: center;
}
.blurry-background {
  filter: blur(8px);
  height: calc(100% + 52px);
  -webkit-filter: blur(8px);
}

.upgrade-modal{
  display: grid;
  position: relative;;
  grid-template-columns: 480px 360px;
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 24px 32px -12px rgba(53, 57, 75, 0.24), 0px 1px 2px 0px rgba(162, 172, 186, 0.16), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  box-shadow: 0px 24px 32px -12px color(display-p3 0.21 0.2233 0.29 / 0.24), 0px 1px 2px 0px color(display-p3 0.6433 0.6728 0.7254 / 0.16), 0px 0px 0px 1px color(display-p3 0.0696 0.2157 0.4104 / 0.08);
  z-index: 10;
  padding: 4px;
}
@media (max-width: 768px) {
  .upgrade-modal {
    grid-template-columns: 1fr;
  }
}

.base-btn {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13),
    0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
  border-radius: 6px;
  padding: 6px 8px 6px 8px;
}

.base-btn:hover {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.17),
    0px 0px 0px 1px rgba(0, 56, 108, 0.12);
}

.legacy-banner{
  background: rgba(6, 7, 15, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-radius: 20px;
  position: absolute;
  left: 0;
  width: 100%;
  height: 60px;

  bottom: calc(100% + 8px);
}

.dark-base-btn{
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.10);
}
</style>
